import { Checkbox } from "tamagui";

import Icon from "@/ui/core/Icon/Icon";
import { FAIconName } from "@/ui/core/Icon/IconDefinitions";
import { ColorToken } from "@/ui/theme/tokens";

const getBackgroundColor = ({
  isChecked,
  isDisabled,
}: {
  isChecked?: boolean;
  isDisabled?: boolean;
}) => {
  if (isDisabled && isChecked) {
    return ColorToken.NeutralTertiary;
  }

  if (!isDisabled && isChecked) {
    return ColorToken.Primary100;
  }

  return ColorToken.NeutralBackgroundPrimary;
};

interface CheckBoxProps extends ViewWithTestID {
  isChecked?: boolean;
  isDisabled?: boolean;
  onChange?: (isChecked: boolean) => Promise<void> | void;
}

const CheckBox = ({
  isChecked,
  isDisabled,
  onChange,
  testID,
}: CheckBoxProps) => {
  const backgroundColor = getBackgroundColor({ isChecked, isDisabled });

  const handleCheckedChange = (shouldBeChecked: boolean) => {
    if (isDisabled) {
      return;
    }
    void onChange?.(shouldBeChecked);
  };

  return (
    <Checkbox
      activeStyle={{ backgroundColor, borderColor: backgroundColor }}
      backgroundColor={backgroundColor}
      borderColor={
        isDisabled ? ColorToken.NeutralLine : ColorToken.NeutralTertiary
      }
      checked={isChecked}
      disabled={isDisabled}
      // web-only: override Tamagui's default gray hover/focus border with the theme default (no-op on native)
      focusStyle={{ borderColor: ColorToken.NeutralTertiary }}
      hoverStyle={{ borderColor: ColorToken.NeutralTertiary }}
      id={testID}
      onCheckedChange={handleCheckedChange}
      // eslint-disable-next-line no-restricted-syntax -- tamagui Checkbox only supports $token sizes, not numbers
      size="$4"
      testID={testID}
    >
      <Checkbox.Indicator disabled={isDisabled}>
        <Icon
          color={ColorToken.NeutralBackgroundPrimary}
          name={FAIconName.Check}
          size="sm"
          testID={testID}
        />
      </Checkbox.Indicator>
    </Checkbox>
  );
};

export default CheckBox;
